import { useEffect } from "react";
import Cookies from "js-cookie";
import { clearSsoCookie } from "../../utils/ssoCookie";

// Reachable directly by URL from zapflow/farm-manager's own logout
// buttons - they're on a different origin so they can't call
// UserContext's logout() directly, and clearing just the shared
// ll_sso_token cookie isn't a real logout: letslaunch's own session
// (authInfo cookie + localStorage token/refreshToken) stayed alive, so
// the next silent-SSO check on /login saw a still-valid session and
// logged the user straight back in. This clears the whole thing, then
// sends the user to a real login form (no redirect param - this is an
// explicit logout, not a bounce-through).
const Logout: React.FC = () => {
  useEffect(() => {
    Cookies.remove("authInfo", {
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
      path: "/",
    });
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userId");
    clearSsoCookie();
    window.location.href = "/login";
  }, []);

  return null;
};

export default Logout;
